import { BillingErrorType, TransactionErrorType } from '../interfaces';

export const showErrorPopUp = (error: string | null) => {
  switch (error) {
    case BillingErrorType.VerifyFunds:
    case BillingErrorType.PaymentDetails:
    case TransactionErrorType.Internal:
    case TransactionErrorType.Connection:
    case TransactionErrorType.ThirdParty:
      return true;
    default:
      return false;
  }
};
